<template lang="html">
    <div class="main-form">
        <div class="main-form__logo">
            <img src="@/assets/images/logo.svg" alt="Nexyo Logo">
        </div>
        <div class="main-form__container">
            <div class="main-form__title" v-if="success === false">
                Recuperare parolă
            </div>

            <UiInput 
                label="Adresă de email"
                type="email"
                placeholder="user@gmail.com"
                :disabled="isLoading"
                :value="email"
                :error="errors.email"
                @input="email = $event; validateEmail()"
                @blur="validateEmail"
                @keyup="sendOnEnter"
                class="mt-4"
                v-if="success === false"
            />

            <div v-if="success === false" class="main-form__text" style="text-align: center;">
                <span>Vei primi un email cu pașii necesari pentru resetarea parolei.</span>
            </div>

            <div class="main-form__title" v-if="success === true">
                Email-ul de recuperare parolă a fost trimis!
            </div>

            <UiButton 
                shape="square"
                :name="isLoading ? 'Se incarcă...' : 'Trimite'"
                @click="sendFogotPassword"
                :disabled="disabledButton"
                v-if="success === false"
            />
            <router-link to="/login" tag="span">
                <div class="main-form__subtext">
                    Înapoi la <a>pagina de autentificare</a>.
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>

import UiInput from '@/components/ui/Input.vue'
import UiButton from '@/components/ui/Button'

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput,
        UiButton
    },
    data() {
        return {
            email: '',
            errors: {
                email: '',
            },
            apiErrors: null,
            success: false,
            isLoading: false,
        }
    },
    mounted() {
        if (this.$route.query.email) {
            this.email = this.$route.query.email;
        }
    },
    methods: {
        ...mapActions({
            sendResetPassword: 'user/sendResetPassword'
        }),
        sendFogotPassword() {
            if(this.disabledButton === false && this.isLoading === false) {
                this.isLoading = true;

                var data = {
                    email: this.email,
                }

                this.sendResetPassword(data);
                this.errors.email = '';
                this.errors.apiErrors = null;
            }
        },
        sendOnEnter(event) {
            if (event.keyCode === 13) {
                this.sendFogotPassword();
            }
        },
        validateEmailFormat(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        validateEmail() {
            this.apiErrors = null;
            if(this.validateEmailFormat(this.email))
                this.errors.email = '';
            else this.errors.email = 'Adresa de email este incorectă!';
        },
    },
    computed: {
        disabledButton() {
            if (this.isLoading) return true;

            if (
                this.errors.email === ''
                && this.email.length > 0
            ) {
                return false;
            }

            return true;
        }
    },
    watch: {
        "$store._modules.root.state.notification.notification.icon"(icon) {
            this.success = (icon === 'success');
		},
        "$store._modules.root.state.notification.notification.title"(notification) {
            this.isLoading = false;
            this.apiErrors = notification;
		}
    }
}
</script>